if (!customElements.get('product-form-v2')) {
  class ProductFormV2 extends HTMLElement {
    constructor() {
      super()
      this.isSubmitting = false
    }

    connectedCallback() {
      this.init()
    }

    init() {
      this.submitButton = this.querySelector('[type="submit"]')
      this.form = this.querySelector('form.js-product-form')
      this.productInfo = this.closest('product-info')
      if (!this.productInfo) {
        this.productInfo = this.closest('quick-add-product-info')
      }
      if (!this.productInfo) return
      if (!this.form) return
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))

      this.addEventListener('click', () => {
        if (
          this.submitButton.disabled &&
          this.productInfo.querySelector('variant-selects input:checked') === null
        ) {
          this.productInfo.querySelector('variant-selects').classList.add('highlight-me')
          setTimeout(
            () => this.productInfo.querySelector('variant-selects').classList.remove('highlight-me'),
            500,
          )
        }
      })
    }

    async onSubmitHandler(evt) {
      evt.preventDefault()
      this.buttonAddToCart = this.querySelector(`#ProductSubmitButton-${this.dataset.sectionId}`);
      document.dispatchEvent(
        new CustomEvent('theme:cart:add', {
          detail: {
            button: this.buttonAddToCart,
          },
        })
      );
      return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.isSubmitting) return

      this.isSubmitting = true
      this.submitButton.setAttribute('aria-disabled', true)
      this.submitButton.classList.add('loading')
      this.querySelector('.loading__spinner').classList.remove('hidden')

      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      delete config.headers['Content-Type']

      const formData = new FormData(this.form)

      let quantity = 1
      let packSize = ''
      if (this.productInfo) {
        quantity = this.productInfo.querySelector('select[name="quantity"]')?.value // Used for data layer
        packSize = this.productInfo.dataset.productPackSize

        formData.append(
          'properties[_cart_source]',
          packSize === 'Single' ? 'PDP Singles' : 'PDP Curated Pack',
        )

        const insiderClubUpsell = this.productInfo.querySelector('#insider-club-upsell')
        if (insiderClubUpsell && insiderClubUpsell.checked) {
          formData.append('items[0][id]', insiderClubUpsell.value)
          if (insiderClubUpsell.dataset.sellingPlan) {
            formData.append('items[0][selling_plan]', insiderClubUpsell.dataset.sellingPlan)
          }
          formData.append('items[0][quantity]', 1)
        }
      }


      config.body = formData

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add`, config)
        const data = await response.json()

        if (data.quantity > 0) {
          if (this.productInfo) {
            const bundleBuilderQuantitySelector = this.productInfo.querySelector(
              'bundle-builder-quantity-selector',
            )
            if (bundleBuilderQuantitySelector) {
              const select = bundleBuilderQuantitySelector.querySelector('select')
              if (select) {
                select.selectedIndex = 0
              }
            }
          }
          document.dispatchEvent(new Event('cartaddsuccess'))

          const quickAddModal = document.querySelector('quick-modal')
          if (quickAddModal) {
            quickAddModal.close()
          }
        }
        if (data.status === 422) {
          alert(data.message)
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.submitButton.classList.remove('loading')
        if (!this.error) this.submitButton.removeAttribute('aria-disabled')
        this.querySelector('.loading__spinner').classList.add('hidden')
        this.isSubmitting = false
      }
    }
  }
  customElements.define('product-form-v2', ProductFormV2)
}
